import React, { useState } from "react";

import { menuInsertApi, menuSearchApi, menuUpdateApi, menuUpdateStatusApi, menuLookupApi } from "../utils/menu-api-action";

const menuSearch = async (param) => {
    var result = await menuSearchApi(param);
    return result;
};
const menuInsert = async (param) => {
    var result = await menuInsertApi(param);
    return result;
};
const menuUpdate = async (param) => {
    var result = await menuUpdateApi(param);
    return result;
};
const menuUpdateStatus = async (param) => {
    var result = await menuUpdateStatusApi(param);
    return result;
};
const menuLookup = async () => {
    var result = await menuLookupApi();
    return result;
};

export { menuSearch, menuInsert, menuUpdate, menuUpdateStatus, menuLookup };
